import React, { Component } from 'react';
import { post, clearBindings, setSubState, nextMeeting, update, remove, get, getDayFromNumber, getNameForType } from '../../util/Utility';
import { FieldGroup, CCOButton, CCOAlert, Select, TimePicker, LocationPicker, CustomButtomView } from '../../util/Components';
import { Well, Collapse, Button, Tooltip, OverlayTrigger, Glyphicon, Radio, FormGroup, ControlLabel, FormControl, Panel, Checkbox} from 'react-bootstrap';

export default class WeeklyView extends Component {

  constructor(props) {
    super(props);

    this.state = {
      base: null,
      title: "",
      show: false,
      titleChanged: false,
      showBase: false,
      directionsAlert: false
    }
  }

  componentWillMount() {
    get('weekly/' + this.props.weekly, this, null, null, false).then(data => this.setState({...data, showBase: (data.type === 'bible' && !data.base.teacher) || !data.base.description}));
  }

  componentWillUnmount() {
    clearBindings();
  }

  save(saveID) {

    let {base, title, ministryID, ...state} = this.state;

    if (!base.atCCO && !base.directionsAvailable && !this.state.directionsAlert) {
      this.setState({directionsAlert: true});
    } else {
      this.setState({directionsAlert: false});
      update('weekly/' + this.props.weekly, this, {base, title, ...state}).then(() => {
        this.setState({saved: saveID});
        setTimeout(() => {
          this.setState({saved: null});
          if ((this.state.type !== 'bible' || this.state.base.teacher) && this.state.base.description) {
            this.setState({showBase: false});
          }
        }, 3000);

        post('ministries/' + ministryID + "/weekly/" + this.props.weekly, this, title);
      }).catch(() => {
        this.setState({networkAlert: saveID});
      });
    }
  }

  delete() {
    update('weekly/' + this.props.weekly, this, {archived: true}).then(() => this.props.archiveCallback());
    remove('ministries/' + this.props.ministry.key + '/weekly/' + this.props.weekly, this);
  }

  publish(val) {
    update('weekly/' + this.props.weekly, this, {show: val}).then(() => this.setState({show: val}));
  }

  render() {

    if (!this.state.base)
      return null;

    const baseTooltip = (
      <Tooltip id="tooltip">These values can be changed on a per-week basis if you need to meet in a different location (for example); the values you enter here are just the defaults.</Tooltip>
    );

    return (
      <center>
        <div style={{maxWidth: 540}}>
          <div style={{textAlign: 'left', marginTop: 20, paddingLeft: 20, paddingRight: 20}}>

            <h4 style={{float: 'left'}}>{"Manage " + getNameForType(this.state.type)}</h4>
            <div style={{float: 'right'}}>
              <Button bsStyle="primary" onClick={() => {
                console.log("button");
                this.setState({showBase: !this.state.showBase});
              }}>{this.state.showBase ? "Hide Settings" : "Show Settings"}</Button>
            </div>

            <div style={{height: 50}} />
            <Collapse in={this.state.showBase}>
              <Well>
                <FormGroup>
                  <ControlLabel>Title</ControlLabel>
                  <FormControl type="text" onChange={e => this.setState({title: e.target.value, titleChanged: true})} value={this.state.title} placeholder="Enter text" />
                </FormGroup>

                <FieldGroup id="description" label="Description" placeholder="Enter Text" context={this} comp="base" componentClass="textarea" />

                <Select id="type" label="Event Type" context={this}>
                  <option key="bible" value="bible">{getNameForType("bible")}</option>
                  <option key="outreach" value="outreach">{getNameForType("outreach")}</option>
                  <option key="fellowship" value="fellowship">{getNameForType("fellowship")}</option>
                  <option key="prayer" value="prayer">{getNameForType("prayer")}</option>
                  {this.props.ministry.key === "cco" && <option key="sunday" value="sunday">{getNameForType("sunday")}</option>}
                </Select>

                <FormGroup>
                  <ControlLabel>Repeats</ControlLabel>
                  <Radio checked={this.state.base.interval === 'weekly'} onChange={() => {
                    setSubState(this, 'base', 'interval', 'weekly');
                    setSubState(this, 'base', 'day', 1);
                  }}>Weekly</Radio>
                  <Radio checked={this.state.base.interval === 'biWeekly'} onChange={() => {
                    setSubState(this, 'base', 'interval', 'biWeekly');
                    setSubState(this, 'base', 'weeklyInterval', '1/3');
                    setSubState(this, 'base', 'day', 1);
                  }}>Bi-Weekly</Radio>
                  <Radio checked={this.state.base.interval === 'monthly'} onChange={() => {
                    setSubState(this, 'base', 'interval', 'monthly');
                    setSubState(this, 'base', 'monthlyType', 'onDay');
                    setSubState(this, 'base', 'day', 1);
                    setSubState(this, 'base', 'dayOfMonth', 1);
                    setSubState(this, 'base', 'weekOfMonth', 1);
                  }}>Monthly</Radio>
                </FormGroup>

                {(this.state.base.interval === 'weekly' || this.state.base.interval === 'biWeekly') && <Select id="day" label="Day of the Week" context={this} comp="base">
                  {Array(7).fill().map((_, number) => <option key={number} value={number}>{getDayFromNumber(number)}</option>)}
                </Select>}

                {this.state.base.interval === 'biWeekly' && <FormGroup>
                  <Radio checked={this.state.base.weeklyInterval === '1/3'} onChange={() => setSubState(this, 'base', 'weeklyInterval', '1/3')}>First & Third {getDayFromNumber(this.state.base.day)} of each month</Radio>
                  <Radio checked={this.state.base.weeklyInterval === '2/4'} onChange={() => setSubState(this, 'base', 'weeklyInterval', '2/4')}>Second & Fourth {getDayFromNumber(this.state.base.day)} of each month</Radio>
                </FormGroup>}

                {this.state.base.interval === 'monthly' && <FormGroup>
                  <div style={{height: 8}} />
                  <div>
                    <Radio checked={this.state.base.monthlyType === 'onDay'} style={{float: 'left', width: 50}} onChange={() => setSubState(this, 'base', 'monthlyType', 'onDay')}>Day </Radio>
                    <FormControl componentClass="select" style={{float: 'left', width: 100, marginTop: -7}} onChange={e => {
                      let base = this.state.base;
                      base.dayOfMonth = parseInt(e.target.value);
                      this.setState({base});
                    }} value={this.state.base.dayOfMonth}>
                      {Array(31).fill().map((_, number) => <option key={number} value={number + 1}>{number + 1}</option>)}
                    </FormControl>
                    <span style={{float: 'left', marginLeft: 10}}> of each month</span>
                  </div>

                  <br></br>
                  <div style={{height: 25}} />

                  <div>
                    <Radio checked={this.state.base.monthlyType === 'onRelativeDate'} style={{float: 'left', width: 70}} onChange={() => setSubState(this, 'base', 'monthlyType', 'onRelativeDate')}>On the </Radio>
                    <FormControl componentClass="select" style={{float: 'left', width: 100, marginTop: -7}} onChange={e => {
                      setSubState(this, 'base', 'weekOfMonth', parseInt(e.target.value));
                    }} value={this.state.base.weekOfMonth}>
                      <option value="1">First</option>
                      <option value="2">Second</option>
                      <option value="3">Third</option>
                      <option value="4">Fourth</option>
                      <option value="0">Last (4th/5th)</option>
                    </FormControl>
                    <FormControl componentClass="select" style={{float: 'left', width: 100, marginTop: -7, marginLeft: 7}} onChange={e => {
                      setSubState(this, 'base', 'day', parseInt(e.target.value));
                    }} value={this.state.base.day}>
                      {Array(7).fill().map((_, number) => <option key={number} value={number}>{getDayFromNumber(number)}</option>)}
                    </FormControl>
                    <span style={{float: 'left', marginLeft: 10}}> of each month</span>
                  </div>

                  <div style={{height: 25}} />
                  <br />
                </FormGroup>}

                <TimePicker comp="base" context={this} />

                <CustomButtomView
                  buttons={this.state.buttons}
                  addButton={newButton => {
                    let buttons = this.state.buttons;
                    if (buttons)
                      buttons.push(newButton);
                    else
                      buttons = [newButton];
                    this.setState({buttons});
                  }}
                  removeButton={index => {
                    let buttons = this.state.buttons;
                    buttons.splice(index, 1);
                    this.setState({buttons});
                  }}
                />

                <h4 style={{paddingTop: 15}}>Base Values <span style={{fontSize: 14}}><OverlayTrigger placement="right" overlay={baseTooltip}><Glyphicon glyph="info-sign" /></OverlayTrigger></span></h4>

                <LocationPicker context={this} comp='base' showLabel />

                {this.state.type === 'bible' && <FieldGroup id="teacher" label="Teacher" placeholder="Enter first and last name" context={this} comp="base" />}

                <CCOAlert in={this.state.directionsAlert} type="warning" title="Unknown Location" content="When typing a location into the text box, please select an option from the dropdown.  If the location does not show in the dropdown and you want to save anyway, just click save again, but note that directions will not be available through the app for this event." />

                <center>
                  <div style={{width: 200}}>
                    <CCOAlert in={this.state.saved === 'base'} type="success" title="Saved" content="Your changes were saved successfully" />
                    <CCOAlert in={this.state.networkAlert === 'base'} type="warning" title="Network Error" content="Could not save because we could not connect to the server, please try again later." />
                    <CCOButton onClick={() => this.save('base')} text="Save Changes" type="primary" />
                    <div style={{height: 20}} />
                    {this.state.show ? <p><Glyphicon glyph="ok" /> Showing in the app</p> : <p><Glyphicon glyph="remove" /> Not showing in the app</p>}
                    {!this.state.show 
                      ? <CCOButton onClick={this.publish.bind(this, true)} text={"Publish " + getNameForType(this.state.type)} type="primary" />
                      : <CCOButton onClick={this.publish.bind(this, false)} text={"Unpublish " + getNameForType(this.state.type)} type="destructive" />}
                    <div style={{height: 20}} />
                    <CCOButton onClick={this.delete.bind(this)} text={"Archive " + getNameForType(this.state.type)} type="destructive" />
                  </div>
                </center>
              </Well>
            </Collapse>
          </div>

          {nextMeeting(this.state.base, 3).map((date, i) => {

            let key = date.unix().toString();

            return (
              <Panel key={key}>
                <center>
                  <h4 style={{margin: 0}}>{i ? "Upcoming" : "Next"} {getNameForType(this.state.type)}</h4>
                  <p className="popoverTextHeader">{date.format("dddd, MMMM Do @ h:mm A")}</p>
                </center>

                <div style={{textAlign: 'left', marginTop: 10}}>
                  {this.state.type === 'bible' && <div>
                    <div style={{height: 10}} />
                    <Checkbox style={{float: 'left'}} checked={this.state[key] && this.state[key].teacher} onChange={() => {
                      setSubState(this, key, 'teacher', '');
                      setSubState(this, key, 'teacherChanged', null);
                    }}>Guest Speaker: </Checkbox>
                    <FormControl placeholder="Type Name to Enable" type="text" style={{float: 'left', width: 250, marginTop: -7, marginLeft: 7}} onChange={e => {
                      setSubState(this, key, 'teacher', e.target.value);
                      if (e) {
                        setSubState(this, key, 'teacherChanged', true);
                      } else {
                        setSubState(this, key, 'teacherChanged', null);
                      }
                    }} value={this.state[key] && this.state[key].teacher} />
                    <div style={{height: 25}} />
                    <br />
                  </div>}

                  <Checkbox checked={this.state[key] && this.state[key].locationChanged} onChange={() => {
                    if (this.state[key] && this.state[key].locationChanged) {
                      setSubState(this, key, 'locationChanged', false);
                      setSubState(this, key, 'location', null);
                      setSubState(this, key, 'atCCO', null);
                    }
                    else
                      setSubState(this, key, 'locationChanged', true);
                  }}>Different Location</Checkbox>

                  {this.state[key] && this.state[key].locationChanged && <div style={{marginLeft: 20}}><LocationPicker comp={key} context={this} /></div>}

                  <Checkbox checked={this.state[key] && this.state[key].canceled} onChange={() => {
                    if (this.state[key] && this.state[key].canceled)
                      setSubState(this, key, 'canceled', false);
                    else
                      setSubState(this, key, 'canceled', true);
                  }}>{getNameForType(this.state.type)} is Canceled</Checkbox>

                  <center>
                    <div style={{width: 250, marginTop: 20}}>
                      <CCOAlert in={this.state.saved === key} type="success" title="Saved" content="Your changes were saved successfully" />
                      <CCOButton text={"Update " + getNameForType(this.state.type) + " Details"} onClick={() => this.save(key)} type="primary" />
                    </div>
                  </center>
                  <div style={{height: 10}} />
                  <CCOAlert in={this.state.networkAlert === key} type="warning" title="Network Error" content="Could not save because we could not connect to the server, please try again later." />
                </div>
              </Panel>
            )
          })}
        </div>
      </center>);
  }
}



/** WEBPACK FOOTER **
 ** ./src/ministry/weekly/WeeklyView.js
 **/